// import React, { useState, useEffect } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import { FaPen } from "react-icons/fa"; // For edit icon

// const ExpertiseCards = ({ visibleCards = [], role }) => {
//   // State for holding expertise cards data
  
//   const [expertiseAreas, setExpertiseAreas] = useState([
//     {
//       icon: (
//         <svg
//           xmlns="http://www.w3.org/2000/svg"
//           fill="none"
//           viewBox="0 0 24 24"
//           strokeWidth={1.5}
//           stroke="currentColor"
//           className="w-6 h-6"
//         >
//           <path
//             strokeLinecap="round"
//             strokeLinejoin="round"
//             d="M13 10V3L4 14h7v7l9-11h-7z"
//           />
//         </svg>
//       ),
//       title: "A Remarkable Real Estate Journey",
//       content:
//         "Brian's real estate career has been nothing short of inspiring. Starting at Compass in California, he quickly rose to prominence in Las Vegas, amassing over $50 million in sales as a principal agent. His innovative use of social media has set him apart, with over 175,000 monthly organic reach on Instagram. Through his candid real estate insights and personal stories, Brian has cultivated a dedicated audience that values his authenticity.",
//     },
//     {
//       icon: (
//         <svg
//           xmlns="http://www.w3.org/2000/svg"
//           fill="none"
//           viewBox="0 0 24 24"
//           strokeWidth={1.5}
//           stroke="currentColor"
//           className="w-6 h-6"
//         >
//           <path
//             strokeLinecap="round"
//             strokeLinejoin="round"
//             d="M12 18v-5.25m0 0a6.01 6.01 0 0 0 1.5-.189m-1.5.189a6.01 6.01 0 0 1-1.5-.189m3.75 7.478a12.06 12.06 0 0 1-4.5 0m3.75 2.383a14.406 14.406 0 0 1-3 0M14.25 18v-.192c0-.983.658-1.823 1.508-2.316a7.5 7.5 0 1 0-7.517 0c.85.493 1.509 1.333 1.509 2.316V18"
//           />
//         </svg>
//       ),
//       title: "Empowering Clients with Knowledge",
//       content:
//         "Brian's philosophy centers around empowering his clients with the knowledge they need to make confident real estate decisions in Lafayette, Moraga, and Orinda. From in-depth market analysis to expert staging tips, he ensures every step of the buying or selling process is handled with professionalism and care. Clients appreciate the wealth of data, insights, and practical advice Brian provides, enabling them to navigate the market successfully.",
//     },
//     {
//       icon: (
//         <svg
//           xmlns="http://www.w3.org/2000/svg"
//           fill="none"
//           viewBox="0 0 24 24"
//           strokeWidth={1.5}
//           stroke="currentColor"
//           className="w-6 h-6"
//         >
//           <path
//             strokeLinecap="round"
//             strokeLinejoin="round"
//             d="M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418"
//           />
//         </svg>
//       ),
//       title:
//         "From Global Experiences to Local Mastery in Lafayette, Moraga, and Orinda",
//       content:
//         "Brian's diverse background spans across roles at major corporations and various industries, enriching his understanding of different cultures and markets. Now settled in Moraga, CA, his international background and multilingual abilities are invaluable in serving both local and international clients throughout Lafayette, Moraga, Orinda and surrounding communities.",
//     },
//     {
//       icon: (
//         <svg
//           xmlns="http://www.w3.org/2000/svg"
//           fill="none"
//           viewBox="0 0 24 24"
//           strokeWidth={1.5}
//           stroke="currentColor"
//           className="w-6 h-6"
//         >
//           <path
//             strokeLinecap="round"
//             strokeLinejoin="round"
//             d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z"
//           />
//         </svg>
//       ),
//       title: "Personalized Service, Every Step of the Way in Las Vegas",
//       content:
//         "Brian takes pride in offering a highly personalized approach. Clients always interact directly with him—whether it's attending appointments, answering calls and texts, or hosting open houses in Lafayette, Moraga, or Orinda. Brian is hands-on every step of the way. While he has a dedicated support team, he remains the primary point of contact, ensuring each client receives his full attention and expertise.",
//     },
//     {
//       icon: (
//         <svg
//           xmlns="http://www.w3.org/2000/svg"
//           fill="none"
//           viewBox="0 0 24 24"
//           strokeWidth={1.5}
//           stroke="currentColor"
//           className="w-6 h-6"
//         >
//           <path
//             strokeLinecap="round"
//             strokeLinejoin="round"
//             d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 0 1 .865-.501 48.172 48.172 0 0 0 3.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z"
//           />
//         </svg>
//       ),
//       title: "Testimonial - A Client's Success Story in Las Vegas",
//       content:
//         "\"Brian was a game-changer for us. He helped us find and secure our ideal home within our budget in a highly competitive market in Las Vegas. His unmatched knowledge of the East Bay, combined with his proactive approach—from arranging early viewings to effective negotiations—was crucial. Brian's meticulousness and all-encompassing services truly differentiate him. We can't recommend him highly enough.\"",
//     },
//     {
//       icon: (
//         <svg
//           xmlns="http://www.w3.org/2000/svg"
//           fill="none"
//           viewBox="0 0 24 24"
//           strokeWidth={1.5}
//           stroke="currentColor"
//           className="w-6 h-6"
//         >
//           <path
//             strokeLinecap="round"
//             strokeLinejoin="round"
//             d="M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21M3 3h12m-.75 4.5H21m-3.75 3.75h.008v.008h-.008v-.008Zm0 3h.008v.008h-.008v-.008Zm0 3h.008v.008h-.008v-.008Z"
//           />
//         </svg>
//       ),
//       title: "More Than an Agent, a Trusted Partner in Las Vegas Real Estate",
//       content:
//         "For anyone looking to buy, sell, or explore the Las Vegas real estate market, Brian is the go-to expert. His approachable nature, combined with his ability to simplify even the most complex transactions, makes him more than just an agent —he's a trusted partner in your real estate journey.",
//     },
//   ]);

//   // Edit states
//   const [showEditForm, setShowEditForm] = useState(false);
//   const [editCards, setEditCards] = useState([]);

//   // Fetch expertise cards data on component mount
//   useEffect(() => {
//     const fetchExpertiseCards = async () => {
//       try {
//         const response = await fetch("/api/get_expertise_cards", {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//           },
//         });
        
//         if (!response.ok) {
//           console.log(`Error status: ${response.status}`);
//           console.log("Using default expertise cards data");
//           return; // Exit early and use default data
//         }
        
//         const data = await response.json();
        
//         if (data && data.length > 0) {
//           // Transform the data to include the icon as JSX
//           const transformedData = data.map(card => {
//             return {
//               ...card,
//               icon: card.icon ? (
//                 <div dangerouslySetInnerHTML={{ __html: card.icon }} />
//               ) : null,
//             };
//           });
//           setExpertiseAreas(transformedData);
//         } else {
//           // If no cards found in DB, we'll use the default state
//           console.log("No cards in response data, using defaults");
//         }
//       } catch (error) {
//         console.error("Error fetching expertise cards data:", error);
//         // Continue using the default state
//       }
//     };

//     fetchExpertiseCards();
//   }, []);

//   // Handle edit button click
//   const handlePenClick = () => {
//     // Create a deep copy and prepare for editing
//     // We need to extract the SVG string from the JSX for editing
//     const cardsForEdit = expertiseAreas.map(card => {
//       let iconString = "";
      
//       if (card.icon && card.icon.props && card.icon.props.dangerouslySetInnerHTML) {
//         // For cards fetched from the database
//         iconString = card.icon.props.dangerouslySetInnerHTML.__html;
//       } else if (card.icon) {
//         // For default cards with JSX icons, we need to serialize them
//         // Just extract the SVG path from the props as a fallback
//         try {
//           // Try to get the path from the SVG
//           if (card.icon.props && card.icon.props.children && card.icon.props.children.props) {
//             const pathProps = card.icon.props.children.props;
            
//             // Basic SVG reconstruction
//             iconString = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" class="w-6 h-6">
//               <path strokeLinecap="round" strokeLinejoin="round" d="${pathProps.d}" />
//             </svg>`;
//           } else {
//             // Fallback for other SVG structures
//             iconString = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" class="w-6 h-6">
//               <path strokeLinecap="round" strokeLinejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" />
//             </svg>`;
//           }
//         } catch (error) {
//           console.error("Error extracting SVG:", error);
//           // Provide a default SVG if extraction fails
//           iconString = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" class="w-6 h-6">
//             <path strokeLinecap="round" strokeLinejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" />
//           </svg>`;
//         }
//       }
      
//       return {
//         id: card.id,
//         icon: iconString,
//         title: card.title,
//         content: card.content
//       };
//     });
    
//     setEditCards(cardsForEdit);
//     setShowEditForm(true);
//   };

//   // Handle saving the edited cards
//   const handleSave = async (e) => {
//     e.preventDefault();
    
//     try {
//       console.log("Sending data to server:", editCards);
      
//       const response = await fetch("/api/save_expertise_cards", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//         },
//         body: JSON.stringify({ cards: editCards }),
//       });
      
//       console.log("Response status:", response.status);
      
//       // Check if response is ok before trying to parse JSON
//       if (!response.ok) {
//         const textResponse = await response.text();
//         console.error("Server error response:", textResponse);
//         throw new Error(`Server returned ${response.status}: ${textResponse.substring(0, 100)}...`);
//       }
      
//       const data = await response.json();
      
//       console.log("Server response:", data);
      
//       // Transform the edited cards back to the format with JSX icons
//       const updatedCards = editCards.map(card => ({
//         ...card,
//         icon: <div dangerouslySetInnerHTML={{ __html: card.icon }} />
//       }));
      
//       setExpertiseAreas(updatedCards);
//       setShowEditForm(false);
//       alert("Expertise cards saved successfully!");
//     } catch (error) {
//       console.error("Error saving expertise cards:", error);
//       alert("An error occurred while saving expertise cards: " + error.message);
//     }
//   };

//   // Handle changing a card field
//   const handleCardChange = (index, field, value) => {
//     const updatedCards = [...editCards];
//     updatedCards[index][field] = value;
//     setEditCards(updatedCards);
//   };

//   return (
//     <div className="relative">
//       {/* Edit button for owner */}
//       {role === "owner" && (
//   <button
//     onClick={handlePenClick}
//     className="absolute top-0 right-0 mt-4 mr-4 text-gray-500 hover:text-gray-700 z-10"
//     title="Edit Expertise Cards"
//   >
//     <FaPen size={18} />
//   </button>
// )}

//       {/* Add a grid container around the cards */}
//       <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
//         {/* Render the expertise cards */}
//         {expertiseAreas.map((area, index) => (
//           <AnimatePresence key={index}>
//             {(!visibleCards.length || visibleCards.includes(index)) && (
//               <motion.div
//                 initial={{ opacity: 0, y: 50 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 exit={{ opacity: 0, y: -50 }}
//                 transition={{ duration: 0.5 }}
//                 className="bg-white p-8 rounded-lg shadow-sm hover:shadow-xl hover:bg-red-500 transition-shadow duration-300 group"
//                 whileHover={{ y: -10 }}
//               >
//                 {/* Icon */}
//                 <motion.div
//                   className="text-red-600 mb-4 group-hover:text-white transition-colors duration-300"
//                   whileHover={{ scale: 1.2, rotate: 15 }}
//                   transition={{ duration: 0.3 }}
//                 >
//                   {area.icon}
//                 </motion.div>

//                 {/* Title */}
//                 <motion.h3
//                   className="text-lg font-bold text-gray-800 mb-4 group-hover:text-white transition-colors duration-300"
//                   initial={{ opacity: 0 }}
//                   animate={{ opacity: 1 }}
//                   transition={{ delay: 0.2, duration: 0.3 }}
//                 >
//                   {area.title}
//                 </motion.h3>

//                 {/* Content */}
//                 {area.content && (
//                   <motion.p
//                     className="text-gray-600 text-sm leading-relaxed text-justify group-hover:text-white transition-colors duration-300"
//                     initial={{ opacity: 0 }}
//                     animate={{ opacity: 1 }}
//                     transition={{ delay: 0.4, duration: 0.3 }}
//                   >
//                     {area.content}
//                   </motion.p>
//                 )}
//               </motion.div>
//             )}
//           </AnimatePresence>
//         ))}
//       </div>

//       {/* Edit Form Modal */}
//       {showEditForm && (
//         <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4 backdrop-blur-sm overflow-y-auto">
//           <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-xl w-full max-w-5xl relative">
//             {/* Modal header */}
//             <div className="flex justify-between items-center mb-6">
//               <h2 className="text-2xl font-bold dark:text-white">Edit Expertise Cards</h2>
//               <button
//                 onClick={() => setShowEditForm(false)}
//                 className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
//               >
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   width="24"
//                   height="24"
//                   fill="none"
//                   stroke="currentColor"
//                   strokeWidth="2"
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                 >
//                   <line x1="18" y1="6" x2="6" y2="18" />
//                   <line x1="6" y1="6" x2="18" y2="18" />
//                 </svg>
//               </button>
//             </div>

//             {/* Cards editing form */}
//             <form onSubmit={handleSave} className="space-y-6 max-h-[70vh] overflow-y-auto p-2">
//               {editCards.map((card, index) => (
//                 <div key={index} className="border p-4 rounded-lg bg-gray-50 dark:bg-gray-700">
//                   <h3 className="text-lg font-semibold mb-4 dark:text-white">Card {index + 1}</h3>
                  
//                   {/* Title field */}
//                   <div className="mb-4">
//                     <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
//                       Title
//                     </label>
//                     <input
//                       type="text"
//                       className="w-full border border-gray-300 dark:border-gray-600 rounded-md px-3 py-2 dark:bg-gray-800 dark:text-white"
//                       value={card.title}
//                       onChange={(e) => handleCardChange(index, 'title', e.target.value)}
//                     />
//                   </div>
                  
//                   {/* Icon field (SVG code) */}
//                   <div className="mb-4">
//                     <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
//                       Icon (SVG code)
//                     </label>
//                     <textarea
//                       rows={4}
//                       className="w-full border border-gray-300 dark:border-gray-600 rounded-md px-3 py-2 font-mono text-sm dark:bg-gray-800 dark:text-white"
//                       value={card.icon}
//                       onChange={(e) => handleCardChange(index, 'icon', e.target.value)}
//                     />
//                   </div>
                  
//                   {/* Content field */}
//                   <div className="mb-2">
//                     <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
//                       Content
//                     </label>
//                     <textarea
//                       rows={5}
//                       className="w-full border border-gray-300 dark:border-gray-600 rounded-md px-3 py-2 dark:bg-gray-800 dark:text-white"
//                       value={card.content}
//                       onChange={(e) => handleCardChange(index, 'content', e.target.value)}
//                     />
//                   </div>
//                 </div>
//               ))}
              
//               {/* Form buttons */}
//               <div className="flex justify-end space-x-3 pt-4 border-t border-gray-200 dark:border-gray-700 sticky bottom-0 bg-white dark:bg-gray-800 p-2">
//                 <button
//                   type="button"
//                   onClick={() => setShowEditForm(false)}
//                   className="px-4 py-2 rounded-md text-gray-700 bg-gray-200 hover:bg-gray-300 transition-colors duration-150 focus:outline-none dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="submit"
//                   className="px-4 py-2 rounded-md bg-blue-600 text-white hover:bg-blue-700 transition-colors duration-150 focus:outline-none"
//                 >
//                   Save Changes
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ExpertiseCards;



















import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaPen } from "react-icons/fa"; // For edit icon

const ExpertiseCards = ({ visibleCards = [], role }) => {
  // State for holding expertise cards data
  const backendUrl = 'https://python-backend-68898252993.us-central1.run.app';

  const [expertiseAreas, setExpertiseAreas] = useState([
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="w-6 h-6"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M13 10V3L4 14h7v7l9-11h-7z"
          />
        </svg>
      ),
      title: "A Remarkable Real Estate Journey",
      content:
        "Brian's real estate career has been nothing short of inspiring. Starting at Compass in California, he quickly rose to prominence in Las Vegas, amassing over $50 million in sales as a principal agent. His innovative use of social media has set him apart, with over 175,000 monthly organic reach on Instagram. Through his candid real estate insights and personal stories, Brian has cultivated a dedicated audience that values his authenticity.",
    },
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="w-6 h-6"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 18v-5.25m0 0a6.01 6.01 0 0 0 1.5-.189m-1.5.189a6.01 6.01 0 0 1-1.5-.189m3.75 7.478a12.06 12.06 0 0 1-4.5 0m3.75 2.383a14.406 14.406 0 0 1-3 0M14.25 18v-.192c0-.983.658-1.823 1.508-2.316a7.5 7.5 0 1 0-7.517 0c.85.493 1.509 1.333 1.509 2.316V18"
          />
        </svg>
      ),
      title: "Empowering Clients with Knowledge",
      content:
        "Brian's philosophy centers around empowering his clients with the knowledge they need to make confident real estate decisions in Lafayette, Moraga, and Orinda. From in-depth market analysis to expert staging tips, he ensures every step of the buying or selling process is handled with professionalism and care. Clients appreciate the wealth of data, insights, and practical advice Brian provides, enabling them to navigate the market successfully.",
    },
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="w-6 h-6"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418"
          />
        </svg>
      ),
      title:
        "From Global Experiences to Local Mastery in Lafayette, Moraga, and Orinda",
      content:
        "Brian's diverse background spans across roles at major corporations and various industries, enriching his understanding of different cultures and markets. Now settled in Moraga, CA, his international background and multilingual abilities are invaluable in serving both local and international clients throughout Lafayette, Moraga, Orinda and surrounding communities.",
    },
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="w-6 h-6"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z"
          />
        </svg>
      ),
      title: "Personalized Service, Every Step of the Way in Las Vegas",
      content:
        "Brian takes pride in offering a highly personalized approach. Clients always interact directly with him—whether it's attending appointments, answering calls and texts, or hosting open houses in Lafayette, Moraga, or Orinda. Brian is hands-on every step of the way. While he has a dedicated support team, he remains the primary point of contact, ensuring each client receives his full attention and expertise.",
    },
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="w-6 h-6"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 0 1 .865-.501 48.172 48.172 0 0 0 3.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z"
          />
        </svg>
      ),
      title: "Testimonial - A Client's Success Story in Las Vegas",
      content:
        "\"Brian was a game-changer for us. He helped us find and secure our ideal home within our budget in a highly competitive market in Las Vegas. His unmatched knowledge of the East Bay, combined with his proactive approach—from arranging early viewings to effective negotiations—was crucial. Brian's meticulousness and all-encompassing services truly differentiate him. We can't recommend him highly enough.\"",
    },
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="w-6 h-6"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21M3 3h12m-.75 4.5H21m-3.75 3.75h.008v.008h-.008v-.008Zm0 3h.008v.008h-.008v-.008Zm0 3h.008v.008h-.008v-.008Z"
          />
        </svg>
      ),
      title: "More Than an Agent, a Trusted Partner in Las Vegas Real Estate",
      content:
        "For anyone looking to buy, sell, or explore the Las Vegas real estate market, Brian is the go-to expert. His approachable nature, combined with his ability to simplify even the most complex transactions, makes him more than just an agent —he's a trusted partner in your real estate journey.",
    },
  ]);

  // Edit states
  const [showEditForm, setShowEditForm] = useState(false);
  const [editCards, setEditCards] = useState([]);

  // Fetch expertise cards data on component mount
  useEffect(() => {
    const fetchExpertiseCards = async () => {
      try {
        const response = await fetch(`${backendUrl}/api/get_expertise_cards`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });
        
        if (!response.ok) {
          console.log(`Error status: ${response.status}`);
          console.log("Using default expertise cards data");
          return; // Exit early and use default data
        }
        
        const data = await response.json();
        
        if (data && data.length > 0) {
          // Transform the data to include the icon as JSX
          const transformedData = data.map(card => {
            return {
              ...card,
              icon: card.icon ? (
                <div dangerouslySetInnerHTML={{ __html: card.icon }} />
              ) : null,
            };
          });
          setExpertiseAreas(transformedData);
        } else {
          // If no cards found in DB, we'll use the default state
          console.log("No cards in response data, using defaults");
        }
      } catch (error) {
        console.error("Error fetching expertise cards data:", error);
        // Continue using the default state
      }
    };

    fetchExpertiseCards();
  }, []);

  // Handle edit button click
  const handlePenClick = () => {
    // Create a deep copy and prepare for editing
    // We need to extract the SVG string from the JSX for editing
    const cardsForEdit = expertiseAreas.map(card => {
      let iconString = "";
      
      if (card.icon && card.icon.props && card.icon.props.dangerouslySetInnerHTML) {
        // For cards fetched from the database
        iconString = card.icon.props.dangerouslySetInnerHTML.__html;
      } else if (card.icon) {
        // For default cards with JSX icons, we need to serialize them
        // Just extract the SVG path from the props as a fallback
        try {
          // Try to get the path from the SVG
          if (card.icon.props && card.icon.props.children && card.icon.props.children.props) {
            const pathProps = card.icon.props.children.props;
            
            // Basic SVG reconstruction
            iconString = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" class="w-6 h-6">
              <path strokeLinecap="round" strokeLinejoin="round" d="${pathProps.d}" />
            </svg>`;
          } else {
            // Fallback for other SVG structures
            iconString = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" class="w-6 h-6">
              <path strokeLinecap="round" strokeLinejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" />
            </svg>`;
          }
        } catch (error) {
          console.error("Error extracting SVG:", error);
          // Provide a default SVG if extraction fails
          iconString = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" class="w-6 h-6">
            <path strokeLinecap="round" strokeLinejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" />
          </svg>`;
        }
      }
      
      return {
        id: card.id,
        icon: iconString,
        title: card.title,
        content: card.content
      };
    });
    
    setEditCards(cardsForEdit);
    setShowEditForm(true);
  };

  // Handle saving the edited cards
  const handleSave = async (e) => {
    e.preventDefault();
    
    try {
      console.log("Sending data to server:", editCards);
      
      const response = await fetch(`${backendUrl}/api/save_expertise_cards`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({ cards: editCards }),
      });
      
      console.log("Response status:", response.status);
      
      // Check if response is ok before trying to parse JSON
      if (!response.ok) {
        const textResponse = await response.text();
        console.error("Server error response:", textResponse);
        throw new Error(`Server returned ${response.status}: ${textResponse.substring(0, 100)}...`);
      }
      
      const data = await response.json();
      
      console.log("Server response:", data);
      
      // Transform the edited cards back to the format with JSX icons
      const updatedCards = editCards.map(card => ({
        ...card,
        icon: <div dangerouslySetInnerHTML={{ __html: card.icon }} />
      }));
      
      setExpertiseAreas(updatedCards);
      setShowEditForm(false);
      alert("Expertise cards saved successfully!");
    } catch (error) {
      console.error("Error saving expertise cards:", error);
      alert("An error occurred while saving expertise cards: " + error.message);
    }
  };

  // Handle changing a card field
  const handleCardChange = (index, field, value) => {
    const updatedCards = [...editCards];
    updatedCards[index][field] = value;
    setEditCards(updatedCards);
  };

  return (
    <div className="relative">
      {/* Edit button for owner */}
      {role === "owner" && (
  <button
    onClick={handlePenClick}
    className="absolute top-0 right-0 mt-4 mr-4 text-gray-500 hover:text-gray-700 z-10"
    title="Edit Expertise Cards"
  >
    <FaPen size={18} />
  </button>
)}

      {/* Add a grid container around the cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* Render the expertise cards */}
        {expertiseAreas.map((area, index) => (
          <AnimatePresence key={index}>
            {(!visibleCards.length || visibleCards.includes(index)) && (
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -50 }}
                transition={{ duration: 0.5 }}
                className="bg-white p-8 rounded-lg shadow-sm hover:shadow-xl hover:bg-red-500 transition-shadow duration-300 group"
                whileHover={{ y: -10 }}
              >
                {/* Icon */}
                <motion.div
                  className="text-red-600 mb-4 group-hover:text-white transition-colors duration-300"
                  whileHover={{ scale: 1.2, rotate: 15 }}
                  transition={{ duration: 0.3 }}
                >
                  {area.icon}
                </motion.div>

                {/* Title */}
                <motion.h3
                  className="text-lg font-bold text-gray-800 mb-4 group-hover:text-white transition-colors duration-300"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 0.2, duration: 0.3 }}
                >
                  {area.title}
                </motion.h3>

                {/* Content */}
                {area.content && (
                  <motion.p
                    className="text-gray-600 text-sm leading-relaxed text-justify group-hover:text-white transition-colors duration-300"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.4, duration: 0.3 }}
                  >
                    {area.content}
                  </motion.p>
                )}
              </motion.div>
            )}
          </AnimatePresence>
        ))}
      </div>

      {/* Edit Form Modal */}
      {showEditForm && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4 backdrop-blur-sm overflow-y-auto">
          <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-xl w-full max-w-5xl relative">
            {/* Modal header */}
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-2xl font-bold dark:text-white">Edit Expertise Cards</h2>
              <button
                onClick={() => setShowEditForm(false)}
                className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </button>
            </div>

            {/* Cards editing form */}
            <form onSubmit={handleSave} className="space-y-6 max-h-[70vh] overflow-y-auto p-2">
              {editCards.map((card, index) => (
                <div key={index} className="border p-4 rounded-lg bg-gray-50 dark:bg-gray-700">
                  <h3 className="text-lg font-semibold mb-4 dark:text-white">Card {index + 1}</h3>
                  
                  {/* Title field */}
                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                      Title
                    </label>
                    <input
                      type="text"
                      className="w-full border border-gray-300 dark:border-gray-600 rounded-md px-3 py-2 dark:bg-gray-800 dark:text-white"
                      value={card.title}
                      onChange={(e) => handleCardChange(index, 'title', e.target.value)}
                    />
                  </div>
                  
                  {/* Icon field (SVG code) */}
                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                      Icon (SVG code)
                    </label>
                    <textarea
                      rows={4}
                      className="w-full border border-gray-300 dark:border-gray-600 rounded-md px-3 py-2 font-mono text-sm dark:bg-gray-800 dark:text-white"
                      value={card.icon}
                      onChange={(e) => handleCardChange(index, 'icon', e.target.value)}
                    />
                  </div>
                  
                  {/* Content field */}
                  <div className="mb-2">
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                      Content
                    </label>
                    <textarea
                      rows={5}
                      className="w-full border border-gray-300 dark:border-gray-600 rounded-md px-3 py-2 dark:bg-gray-800 dark:text-white"
                      value={card.content}
                      onChange={(e) => handleCardChange(index, 'content', e.target.value)}
                    />
                  </div>
                </div>
              ))}
              
              {/* Form buttons */}
              <div className="flex justify-end space-x-3 pt-4 border-t border-gray-200 dark:border-gray-700 sticky bottom-0 bg-white dark:bg-gray-800 p-2">
                <button
                  type="button"
                  onClick={() => setShowEditForm(false)}
                  className="px-4 py-2 rounded-md text-gray-700 bg-gray-200 hover:bg-gray-300 transition-colors duration-150 focus:outline-none dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 rounded-md bg-blue-600 text-white hover:bg-blue-700 transition-colors duration-150 focus:outline-none"
                >
                  Save Changes
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default ExpertiseCards;